import React from "react";
import binIcon from "../../images/bin2.svg";
import { isValidEmail } from "../../utils/common";
interface EmailCardProps {
  primaryEmail: string;
  emails: string[];
  setEmails: (emails: string[]) => void;
}
const EmailCard: React.FC<EmailCardProps> = (props) => {
  const { emails, setEmails, primaryEmail } = props;
  return (
    <div className="card">
      <div className="cardTitle">邮箱设置</div>
      <div className="block2">
        <label className="primaryLabel">订单信息将发送至</label>
        <span className="primaryText">{primaryEmail}</span>
      </div>
      <div className="block3">
        <label className="primaryLabel">增加额外电子邮箱</label>
      </div>
      {emails.map((email, index) => {
        return (
          <div key={index} className="gap8">
            <div className="emailItem">
            <div className="email">
              <input
                className="input"
                value={email}
                maxLength={50}
                onChange={(e: any) => {
                  emails[index] = e.target.value;
                  setEmails([...emails]);
                }}
              ></input>
            </div>
            <span
              className="deleteIcon"
              onClick={() => {
                if (emails.length === 1) {return}
                emails.splice(index, 1);
                setEmails([...emails]);
              }}
            >
              <img src={binIcon} alt="delete"></img>
            </span>
            </div>
            <div className="errWrapper">{ !email || isValidEmail(email) ? '': '无效格式'}</div>
          </div>
        );
      })}
      <div className="gap12">
        <span
          style={{fontSize: '14px', fontWeight: 700}}
          className="textLink"
          onClick={() => {
            setEmails([...emails, ""]);
          }}
        >
          +其他电子邮件
        </span>
      </div>
    </div>
  );
};

export default EmailCard;
